import { Separator } from "@/client/components/shad/separator";
import { usePdarView } from "./hooks/usePadrView";
import { PdarCalander } from "./PdarCalander";

import { PdarSpectagram } from "./PdarSpectagram";
import { PdarStations } from "./PdarStations";
import { PdarTargets } from "./PdarTargets";
import { PdarControls } from "./PdarControls";

export const PdarView = () => {
  const { view } = usePdarView();

  if (view === "pdars") {
    return (
      <>
        <div className="h-2"></div>
        <PdarStations />
      </>
    );
  }

  if (view === "logs") {
    return <PdarLogs />;
  }

  if (view === "analytics") {
    return <PdarAnalytics />;
  }

  return (
    <>
      <PdarTargets />
      <PdarControls />
    </>
  );
};

const PdarLogs = () => {
  return (
    <div>
      <PdarCalander />
    </div>
  );
};

const PdarAnalytics = () => {
  return (
    <div>
      <PdarSpectagram />
    </div>
  );
};
